import React, { useState } from "react";
import { components } from "react-select";
import Popup from "reactjs-popup";
import { useSelector, useDispatch } from "react-redux";
import { crtobr } from "../utils";
import { RiCloseFill } from "react-icons/ri";

export default function InfoPopup(props) {
  
  const {popupOpen,setPopupOpen,text} = props;

  return (
    <Popup
      open={popupOpen}
      position="center"
      modal
      onClose={() => {
        setPopupOpen(false);
      }}
    >       <div className="infopopupclose" onClick={()=>setPopupOpen(false)}>
    <RiCloseFill/>
    </div>
      <div className="infopopup">{crtobr(text)}</div>
    </Popup>
  );
}
